import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="mb-3">
        Когда-то ягуар был полностью жёлтым, как лев. 
        Но характер у него оставался таким же, как и сейчас. 
        «Самый свирепый зверь в джунглях», - говорили о нём.
      </p>
      
      <p class="mb-3">
        Всё живое боялось ягуара. 
        Но однажды на его спину села бабочка, чудная коричневая бабочка с большими полукруглыми крыльями. 
        Она взмахнула ими, и ягуару почудилось лёгкое дуновение ветерка, ласкающее его шкуру. 
        Раньше его никто не ласкал; его только ненавидели и боялись.
      </p>
      
      <p class="mb-3">
        Ему захотелось, чтобы бабочка не улетала, чтобы она всегда оставалась с ним и ласково касалась его кожи. 
        И бабочке тоже понравилось сидеть на спине ягуара: ведь теперь все замечали её, раньше такую маленькую и коричневую, и вдруг все поняли, 
        что она замечательно красива и крылья её отливают золотом.
      </p>
      
      <p class="mb-3">
        Ягуар и бабочка решили больше не разлучаться. 
        Скоро вся шкура ягуара покрылась прекрасными коричневыми бабочками, потомками той первой. 
      </p>
      
      <p class="mb-3">
        Вот почему у ягуара вся шкура в коричневых пятнах. 
      </p>
      
    </div>
    `
  )
}

const itemName = {
  rus: `Почему у ягуара пятнистая шкура`
}


const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;